<template>
  <v-tile
    :product="product"
    class="c-tile--logo"
  >
    <v-product-image
      :product="product"
      :type="ImageType.SQUARE_MINI"
      class="c-tile__image"
    ></v-product-image>
    <v-badge
      :product="product"
      class="c-tile__badge c-tile__badge--left"
    ></v-badge>
  </v-tile>
</template>
<script>
  import { ImageType } from '@/shared/enums';
  import { VBadge, VProductImage, VTile } from '@/index/shared/components';

  export default {
    components: {
      VBadge,
      VProductImage,
      VTile,
    },
    enums: {
      ImageType,
    },
    props: {
      product: Object,
    },
  };
</script>
